<template>
  <!-- 信用风险等级评估 -->
  <card-edit
    ref="cardEditComp"
    :source-data="sourceData"
    :schema="CREDIT_RISKING_SCHEMA"
    :gutter="gutter"
  ></card-edit>
</template>

<script>
import { CardEdit } from 'lxfintech-fe'
import { CREDIT_RISKING_SCHEMA } from './schema'
import { getRiskEvaluate, calcEvaluate } from './api'

export default {
  name: 'CreditRiskRating',
  data() {
    return {
      sourceData: {
        id: '',
        companyCode: '',
        companyName: '',
        creditLevel: '',
        timeRisk: '',
        currentStock: '',
        targetPurchase: '',
        weekAvgShipment: '',
        promotionWeek: '',
        avgStockWeek: '',
        currentStockWeek: '',
        planStockWeek: '',
        insuranceCoverageStr: '',
        subjectiveEvaluation: '',
      },
      CREDIT_RISKING_SCHEMA,
      gutter: { xs: 8, sm: 16, md: 24, lg: 24 },
    }
  },
  props: [''],
  methods: {
    async getRiskData(params) {
      try {
        const { data } = await getRiskEvaluate(params)
        for (let key in data) {
          if (typeof this.sourceData[key] !== 'undefined') {
            this.sourceData[key] = data[key]
          }
        }
        return data
      } catch (error) {
        console.error(error)
      }
    },
    async _calcEvaluate() {
      try {
        const values = await this.$refs.cardEditComp.handleSubmit()
        if (values) {
          const {
            companyCode,
            timeRisk,
            currentStock,
            targetPurchase,
            weekAvgShipment,
            promotionWeek,
            subjectiveEvaluation,
          } = values
          let params = {
            companyCode,
            timeRisk,
            currentStock,
            targetPurchase,
            weekAvgShipment,
            promotionWeek,
            subjectiveEvaluation,
          }
          const { data } = await calcEvaluate(params)
          ;({
            currentStockWeek: this.sourceData.currentStockWeek,
            planStockWeek: this.sourceData.planStockWeek,
            avgStockWeek: this.sourceData.avgStockWeek,
            insuranceCoverageStr: this.sourceData.insuranceCoverageStr,
          } = data)
          return data
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
  components: {
    CardEdit,
  },
}
</script>

<style></style>
